export const fonte = "https://gilbertomelo.com.br/pdf/JEBR1026N.pdf";


let indices = [];


indices["2005"] = [
  3.2103856,
  3.1921902,
  3.1782060,
  3.1551733,
  3.1267201,
  3.1049852,
  3.1084045,
  3.1074722,
  3.1074722,
  3.1028180,
  3.0849254,
  3.0683563,
];


indices["2006"] = [
  3.0561318,
  3.0445624,
  3.0375760,
  3.0293967,
  3.0257657,
  3.0218373,
  3.0239541,
  3.0206314,
  3.0212357,
  3.0164094,
  3.0034944,
  2.9909325,
];


indices["2007"] = [
  2.9725030,
  2.9580087,
  2.9456370,
  2.9327330,
  2.9251277,
  2.9175421,
  2.9085256,
  2.8992480,
  2.8822428,
  2.8750552,
  2.8664558,
  2.8541828,
];


indices["2008"] = [
  2.8267632,
  2.8073922,
  2.7939811,
  2.7798041,
  2.7621265,
  2.7358622,
  2.7111904,
  2.6955562,
  2.6899073,
  2.6858785,
  2.6725160,
  2.6623988,
];


indices["2009"] = [
  2.6547002,
  2.6378182,
  2.6296662,
  2.6244174,
  2.6100620,
  2.5944951,
  2.5836438,
  2.5777150,
  2.5756545,
  2.5715400,
  2.5653831,
  2.5559262,
];


indices["2010"] = [
  2.5498066,
  2.5275641,
  2.5099941,
  2.4922988,
  2.4742369,
  2.4636432,
  2.4663562,
  2.4680839,
  2.4698127,
  2.4565474,
  2.4341532,
  2.4093370,
];


indices["2011"] = [
  2.3949672,
  2.3726641,
  2.3599206,
  2.3444472,
  2.3276879,
  2.3144952,
  2.3094145,
  2.3094145,
  2.2997556,
  2.2894530,
  2.2821501,
  2.2692156,
];


indices["2012"] = [
  2.2577013,
  2.2462455,
  2.2375192,
  2.2334989,
  2.2192954,
  2.2071560,
  2.2014323,
  2.1920067,
  2.1821868,
  2.1685251,
  2.1532371,
  2.1416721,
];


indices["2013"] = [
  2.1259401,
  2.1065598,
  2.0956623,
  2.0831634,
  2.0709448,
  2.0637218,
  2.0579595,
  2.0606383,
  2.0573465,
  2.0518067,
  2.0393665,
  2.0284131,
];


indices["2014"] = [
  2.0139129,
  2.0013047,
  1.9885778,
  1.9724041,
  1.9571384,
  1.9454656,
  1.9404205,
  1.9379013,
  1.9344193,
  1.9249869,
  1.9176996,
  1.9075894,
];


indices["2015"] = [
  1.8958352,
  1.8681861,
  1.8467636,
  1.8192923,
  1.8064664,
  1.7887577,
  1.7750895,
  1.7648533,
  1.7604522,
  1.7515195,
  1.7381358,
  1.7190543,
];


indices["2016"] = [
  1.7037208,
  1.6783773,
  1.6625828,
  1.6552995,
  1.6447729,
  1.6288106,
  1.6211910,
  1.6108813,
  1.6059030,
  1.6046193,
  1.6018961,
  1.6007756,
];


indices["2017"] = [
  1.5985376,
  1.5918518,
  1.5880406,
  1.5829750,
  1.5817097,
  1.5760359,
  1.5807783,
  1.5780955,
  1.5785691,
  1.5788849,
  1.5730645,
  1.5702381,
];


indices["2018"] = [
  1.5661661,
  1.5625721,
  1.5597646,
  1.5586735,
  1.5554071,
  1.5487475,
  1.5269127,
  1.5231049,
  1.5231049,
  1.5185493,
  1.5124993,
  1.5162900,
];


indices["2019"] = [
  1.5141702,
  1.5087387,
  1.5006353,
  1.4891687,
  1.4802869,
  1.4780698,
  1.4779220,
  1.4764456,
  1.4746760,
  1.4754137,
  1.4748238,
  1.4669025,
];


indices["2020"] = [
  1.4492220,
  1.4464737,
  1.4440189,
  1.4414243,
  1.4447472,
  1.4483681,
  1.4440360,
  1.4377101,
  1.4325529,
  1.4201972,
  1.4076689,
  1.3944219,
];


indices["2021"] = [
  1.3743563,
  1.3706556,
  1.3595076,
  1.3479155,
  1.3428128,
  1.3300444,
  1.3221117,
  1.3087624,
  1.2973457,
  1.2819622,
  1.2672619,
  1.2567056,
];


indices["2022"] = [
  1.2475981,
  1.2392949,
  1.2270246,
  1.2063953,
  1.1939779,
  1.1886291,
  1.1813050,
  1.1884356,
  1.1921312,
  1.1959583,
  1.1903635,
  1.1858573,
];


indices["2023"] = [
  1.1777309,
  1.1723382,
  1.1633802,
  1.1559819,
  1.1498875,
  1.1457627,
  1.1469096,
  1.1479428,
  1.1456515,
  1.1443926,
  1.1430210,
  1.1418791,
];


indices["2024"] = [
  1.1356332,
  1.1291967,
  1.1201237,
  1.1179995,
  1.1138782,
  1.1087778,
  1.1060128,
  1.1031446,
  1.1046912,
  1.0998518,
  1.0937270,
  1.0894780,
];


indices["2025"] = [
  1.0838420,
  1.0821106,
  1.0681183,
  1.0621701,
  1.0576224,
  1.0548797,
  1.0523540,
  1.0496250,
  1.0507809,
  1.0457612,
  1.0448209,
  1.0429436,
];


indices["2026"] = [
  1.0395132,
  1.0360941,
  1.0288918,
  1.0199165,
  1.0131286,
  1.0072863,
  1.0056772,
  1.0049738,
  1.0082000,
  1.0000000,
];


export default indices;



// WEBPACK FOOTER //
// ./src/config/indices.js